import ajax from "../index.js";

export default class BoxServe {
  // 分页获取盒子设备列表
  static boxdeviceList(params) {
    return ajax.postJson(`/boxdevice/pagelist`, params, {
      "Content-Type": "application/x-www-form-urlencoded"
    });
  }

  // 分页获取上游业务管理列表
  static upcompanyList(params) {
    return ajax.postJson("/upcompany/list", params, {
      "Content-Type": "application/x-www-form-urlencoded"
    });
  }

  // 获取所有命令或某个盒子执行命令列表
  static getTasklogList(params) {
    return ajax.postJson("/tasklog/list", params, {
      "Content-Type": "application/x-www-form-urlencoded"
    });
  }

  // 获取当前命令执行结果
  static getCurrentCommandResult(params) {
    return ajax.get(`/tasklog/detail/${params}`);
  }

  // 修改盒子设备的上游业务
  static updateDevice(params) {
    return ajax.postJson("/boxdevice/updateDevice", params);
  }

  // 分页获取盒子流量列表
  static getTflowList(params) {
    return ajax.postJson("/tflow/list", params, {
      "Content-Type": "application/x-www-form-urlencoded"
    });
  }

  // 向盒子发送长期任务命令
  static sendLongBatchCmd(params) {
    return ajax.postJson("/tasklog/sendLongBatchCmd", params, {
      "Content-Type": "application/json"
    });
  }

  // 给多个盒子发送短期任务命令
  static sendBatchRemoteCmd(params) {
    return ajax.postJson("/tasklog/sendBatchRemoteCmd", params);
  }

  // 分页获取批次号列表
  static getPageBatchList(params) {
    return ajax.postJson("/tasklog/pageBatchList", params, {
      "Content-Type": "application/x-www-form-urlencoded"
    });
  }

  // 获取验证码
  static getCaptcha() {
    return ajax.downloadGet(`/captcha`);
  }

  // 登录
  static getLogin(params) {
    return ajax.postJson("/login", params);
  }

  // 获取cpu负载
  static getPageCpuList(params) {
    return ajax.postJson("/tflow/pageCpuList", params, {
      "Content-Type": "application/x-www-form-urlencoded"
    });
  }

  // 获取内存记录
  static getPageMemList(params) {
    return ajax.postJson("/tflow/pageMemList", params, {
      "Content-Type": "application/x-www-form-urlencoded"
    });
  }

  // 获取存储
  static getPageStorageList(params) {
    return ajax.postJson("/tflow/pageStorageList", params, {
      "Content-Type": "application/x-www-form-urlencoded"
    });
  }

  // 分页获取派享x86设备列表
  static getTpxdeviceList(params) {
    return ajax.postJson("/tpxdevice/pagelist", params, {
      "Content-Type": "application/x-www-form-urlencoded"
    });
  }

  // 开始对设备压测
  static addBandTest(params) {
    return ajax.postJson("/bandwidthtest/addBandTest", params);
  }

  // 分页获取设备压测记录列表
  static bandwidthtestList(params) {
    return ajax.postJson("/bandwidthtest/list", params, {
      "Content-Type": "application/x-www-form-urlencoded"
    });
  }

  // 分页获取设备压测记录列表
  static updateBoxInfo(params) {
    return ajax.postJson("/boxdevice/updateBoxInfo", params);
  }

  // 开启设备的远程设置功能
  static sendStartFrp(params) {
    return ajax.postJson("/tasklog/sendStartFrp", params);
  }

  // 切换上游记录
  static businessList(params) {
    return ajax.postJson("/business/list", params, {
      "Content-Type": "application/x-www-form-urlencoded"
    });
  }

  // 操作命令
  static commandList(params) {
    return ajax.postJson("/command/list", params, {
      "Content-Type": "application/x-www-form-urlencoded"
    });
  }

  // 设置盒子设备限速策略
  static updateLimitBandwidth(params) {
    return ajax.postJson("/boxdevice/updateLimitBandwidth", params);
  }
}
